var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.33 175.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272726;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.57,175.26V35.57h57.24c17.73,0,31.88,4.47,42.05,13.28h0c10.55,9.16,15.9,21.91,15.9,37.92s-5.34,29.72-15.89,39.15c-10.22,9.17-24.38,13.82-42.06,13.82h-21.63v35.52h21.62c5.01,0,9.85-.28,14.54-.8,20.19-2.4,37.73-9.9,51.28-22.05,18.12-16.21,27.71-38.92,27.71-65.64s-9.36-47.92-27.09-63.84l-.12-.12-.96-.83C141.33,7.39,119.34,0,92.81,0H0v175.26h35.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m110.8,74.38c-3.97-3.18-10.26-4.8-18.7-4.8l-20.91.12v36.02h20.91c8.4,0,14.67-1.65,18.61-4.9,2.21-1.82,5.14-5.19,5.14-13.53s-2.88-11.18-5.05-12.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdMark);
export default __webpack_public_path__ + "static/media/pd-mark.7199bc22176cc4f8fd9615896293c3f2.svg";
export { ForwardRef as ReactComponent };